import { useState } from "react";
import { Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Field } from "@/components/common";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

const TYPES = [["percent", "Desconto em %"], ["fixed", "Desconto em R$"], ["free_delivery", "Entrega grátis"]];

export function CouponSettingsCard({ initial, onSaved }) {
  const [c, setC] = useState(initial);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setC((x) => ({ ...x, [k]: v }));
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/ratings/coupon-settings", { ...c, value: Number(c.value) || 0, min_order: Number(c.min_order) || 0, valid_days: Number(c.valid_days) || 30 });
      setC(data); onSaved?.(data); toast.success("Cupom de agradecimento salvo");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="card-surface p-5 space-y-4" data-testid="coupon-settings-card">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="font-semibold flex items-center gap-2"><Gift className="h-4 w-4 text-primary" />Cupom de agradecimento</p>
          <p className="text-sm text-muted-foreground max-w-2xl">Quem der 5 estrelas ganha o cupom na hora, na tela de acompanhamento do pedido. Cada cupom vale uma vez no cardápio digital (entrega, retirada ou consumo no local).</p>
        </div>
        <label className="flex items-center gap-2 text-sm font-medium">{c.enabled ? "Ativado" : "Desativado"}<Switch checked={c.enabled} onCheckedChange={(v) => set("enabled", v)} data-testid="coupon-enabled-switch" /></label>
      </div>
      <div className={`grid sm:grid-cols-2 lg:grid-cols-4 gap-4 ${c.enabled ? "" : "opacity-60"}`}>
        <Field label="Tipo de cupom">
          <select value={c.type} onChange={(e) => set("type", e.target.value)} className="h-10 rounded-md border bg-transparent px-2 text-sm" data-testid="coupon-type-select">
            {TYPES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </Field>
        {c.type !== "free_delivery" && <Field label={c.type === "percent" ? "Desconto (%)" : "Desconto (R$)"}><Input type="number" min="0" step="0.5" value={c.value} onChange={(e) => set("value", e.target.value)} data-testid="coupon-value-input" /></Field>}
        <Field label="Compra mínima para ganhar (R$)" hint="Valor dos produtos do pedido avaliado; 0 = qualquer valor"><Input type="number" min="0" step="1" value={c.min_order} onChange={(e) => set("min_order", e.target.value)} data-testid="coupon-min-order-input" /></Field>
        <Field label="Validade (dias)"><Input type="number" min="1" max="365" value={c.valid_days} onChange={(e) => set("valid_days", e.target.value)} data-testid="coupon-valid-days-input" /></Field>
      </div>
      <Button onClick={save} disabled={busy} data-testid="coupon-settings-save-btn">Salvar cupom</Button>
    </div>
  );
}
